<template>
	<div class="container">
		<header class="page-header">
			<h1 class="page-title-2">Frequently Asked Questions</h1>
		</header>
	<div class="accordion md-accordion" id="accordionEx1" role="tablist" aria-multiselectable="true">

 <section class="accordion-section clearfix mt-3" aria-label="Question Accordions">
  <div class="container">
		
		<div class="panel panel-default">
		  <div class="panel-heading p-3 mb-3" role="tab" id="heading1">
			<h3 class="panel-title">
			  <a class="collapsed" role="button" title="" data-toggle="collapse" data-parent="#accordion" href="#collapse1" aria-expanded="true" aria-controls="collapse1">
				How do I register?
			  </a>
			</h3>
		  </div>
		  <div id="collapse1" class="panel-collapse collapse" role="tabpanel" aria-labelledby="heading1">
			<div class="panel-body px-3 mb-4">
			  <p>Click Register button on top of the page. After that, fill in all the details and click the register button.</p>
			</div>
		  </div>
		</div>
		
		<div class="panel panel-default">
		  <div class="panel-heading p-3 mb-3" role="tab" id="heading2">
			<h3 class="panel-title">
			  <a class="collapsed" role="button" title="" data-toggle="collapse" data-parent="#accordion" href="#collapse2" aria-expanded="true" aria-controls="collapse2">
				How do I login?
			  </a>
			</h3>
		  </div>
		  <div id="collapse2" class="panel-collapse collapse" role="tabpanel" aria-labelledby="heading2">
			<div class="panel-body px-3 mb-4">
			  <p>You have to register first before you can login. If you are already registered, just click sign in button and insert your email/username and password.</p>
			</div>
		  </div>
		</div>
		
		<div class="panel panel-default">
		  <div class="panel-heading p-3 mb-3" role="tab" id="heading3">
			<h3 class="panel-title">
			  <a class="collapsed" role="button" title="" data-toggle="collapse" data-parent="#accordion" href="#collapse3" aria-expanded="true" aria-controls="collapse3">
				What if I forgot my password?
			  </a>
			</h3>
		  </div>
		  <div id="collapse3" class="panel-collapse collapse" role="tabpanel" aria-labelledby="heading3">
			<div class="panel-body px-3 mb-4">
			  <p>Click “Forgot Password” button and insert your email. After that, check your email and recover your password.</p>
			</div>
		  </div>
		</div>


	  	<div class="panel panel-default">
		  <div class="panel-heading p-3 mb-3" role="tab" id="heading4">
			<h3 class="panel-title">
			  <a class="collapsed" role="button" title="" data-toggle="collapse" data-parent="#accordion" href="#collapse4" aria-expanded="true" aria-controls="collapse4">
				How do I update my user profile?
			  </a>
			</h3>
		  </div>
		  <div id="collapse4" class="panel-collapse collapse" role="tabpanel" aria-labelledby="heading4">
			<div class="panel-body px-3 mb-4">
			  <p>You must open the Toolaku dashboard first. After that, click on setting and update your profile there.</p>
			</div>
		  </div>
		</div>

		<div class="panel panel-default">
		  <div class="panel-heading p-3 mb-3" role="tab" id="heading5">
			<h3 class="panel-title">
			  <a class="collapsed" role="button" title="" data-toggle="collapse" data-parent="#accordion" href="#collapse5" aria-expanded="true" aria-controls="collapse5">
				How do I register my company?
			  </a>
			</h3>
		  </div>
		  <div id="collapse5" class="panel-collapse collapse" role="tabpanel" aria-labelledby="heading5">
			<div class="panel-body px-3 mb-4">
			  <p>You must open the Toolaku dashboard first. After that, click on company profile and register your company there.</p>
			</div>
		  </div>
		</div>

		<!-- <div class="panel panel-default">
		  <div class="panel-heading p-3 mb-3" role="tab" id="heading6">
			<h3 class="panel-title">
			  <a class="collapsed" role="button" title="" data-toggle="collapse" data-parent="#accordion" href="#collapse6" aria-expanded="true" aria-controls="collapse6">
				How do I update my company profile?
			  </a>
			</h3>
		  </div>
		  <div id="collapse6" class="panel-collapse collapse" role="tabpanel" aria-labelledby="heading6">
			<div class="panel-body px-3 mb-4">
			  <p>Yes, Solodev CMS is built to handle the needs of any size company. With our Multi-Site Management, you will be able to easily manage all of your websites.</p>
			</div>
		  </div>
		</div> -->

		<div class="panel panel-default">
		  <div class="panel-heading p-3 mb-3" role="tab" id="heading7">
			<h3 class="panel-title">
			  <a class="collapsed" role="button" title="" data-toggle="collapse" data-parent="#accordion" href="#collapse7" aria-expanded="true" aria-controls="collapse7">
				What can I search for?
			  </a>
			</h3>
		  </div>
		  <div id="collapse7" class="panel-collapse collapse" role="tabpanel" aria-labelledby="heading7">
			<div class="panel-body px-3 mb-4">
			  <p>You can search for product name, service name and company name.</p>
			</div>
		  </div>
		</div>

		<!-- <div class="panel panel-default">
		  <div class="panel-heading p-3 mb-3" role="tab" id="heading8">
			<h3 class="panel-title">
			  <a class="collapsed" role="button" title="" data-toggle="collapse" data-parent="#accordion" href="#collapse8" aria-expanded="true" aria-controls="collapse8">
				How is information catalogued in Toolaku?
			  </a>
			</h3>
		  </div>
		  <div id="collapse8" class="panel-collapse collapse" role="tabpanel" aria-labelledby="heading8">
			<div class="panel-body px-3 mb-4">
			  <p>Yes, Solodev CMS is built to handle the needs of any size company. With our Multi-Site Management, you will be able to easily manage all of your websites.</p>
			</div>
		  </div>
		</div> -->

		<div class="panel panel-default">
		  <div class="panel-heading p-3 mb-3" role="tab" id="heading9">
			<h3 class="panel-title">
			  <a class="collapsed" role="button" title="" data-toggle="collapse" data-parent="#accordion" href="#collapse9" aria-expanded="true" aria-controls="collapse9">
				How does the “Request Quotation” work?
			  </a>
			</h3>
		  </div>
		  <div id="collapse9" class="panel-collapse collapse" role="tabpanel" aria-labelledby="heading9">
			<div class="panel-body px-3 mb-4">
			  <p>Click "Request for Quotation" on any product or services. After that, insert the quantity and message and click "Send RFQ". Then, you can check on the RFQ in "Quote Me" module.</p>
			</div>
		  </div>
		</div>

		<div class="panel panel-default">
		  <div class="panel-heading p-3 mb-3" role="tab" id="heading10">
			<h3 class="panel-title">
			  <a class="collapsed" role="button" title="" data-toggle="collapse" data-parent="#accordion" href="#collapse10" aria-expanded="true" aria-controls="collapse10">
				How does the “Inquiry” work?
			  </a>
			</h3>
		  </div>
		  <div id="collapse10" class="panel-collapse collapse" role="tabpanel" aria-labelledby="heading10">
			<div class="panel-body px-3 mb-4">
			  <p>Click "Inquiry" on any product or services. After that insert your email and any message you want to inquire. Click “Send a Message” to submit your inquiries.</p>
			</div>
		  </div>
		</div>

		<div class="panel panel-default">
		  <div class="panel-heading p-3 mb-3" role="tab" id="heading11">
			<h3 class="panel-title">
			  <a class="collapsed" role="button" title="" data-toggle="collapse" data-parent="#accordion" href="#collapse11" aria-expanded="true" aria-controls="collapse11">
				Can I view the inquiries I have sent?
			  </a>
			</h3>
		  </div>
		  <div id="collapse11" class="panel-collapse collapse" role="tabpanel" aria-labelledby="heading11">
			<div class="panel-body px-3 mb-4">
			  <p>Yes. Open the “Quote Me” module, and click on inquiries to view the inquiries you have sent.</p>
			</div>
		  </div>
		</div> 

		<div class="panel panel-default">
		  <div class="panel-heading p-3 mb-3" role="tab" id="heading12">
			<h3 class="panel-title">
			  <a class="collapsed" role="button" title="" data-toggle="collapse" data-parent="#accordion" href="#collapse12" aria-expanded="true" aria-controls="collapse12">
				How do I add my product?
			  </a>
			</h3>
		  </div>
		  <div id="collapse12" class="panel-collapse collapse" role="tabpanel" aria-labelledby="heading12">
			<div class="panel-body px-3 mb-4">
			  <p>Open the “My Product” module and click on add new product. After that, insert all the information required.</p>
			</div>
		  </div>
		</div>

		<div class="panel panel-default">
		  <div class="panel-heading p-3 mb-3" role="tab" id="heading13">
			<h3 class="panel-title">
			  <a class="collapsed" role="button" title="" data-toggle="collapse" data-parent="#accordion" href="#collapse13" aria-expanded="true" aria-controls="collapse13">
				How do I add my service?
			  </a>
			</h3>
		  </div>
		  <div id="collapse13" class="panel-collapse collapse" role="tabpanel" aria-labelledby="heading13">
			<div class="panel-body px-3 mb-4">
			  <p>Open the “My Services” module and click on add new service. After that, insert all the information required.</p>
			</div>
		  </div>
		</div>

  
  </div>
</section>
	</div>
</div>
</template>

<script>
	export default {
		components: {
			//
		},
		data() {
			return {
				authKey: null
			}
		},
		created() {
			//
		}
	}
</script>
